import {
  CompetitionSelector,
  DateRangeSelector,
  FilterScopeProvider,
  PlayerSelector,
  ResetAllFiltersButton,
  SeasonSelector,
  TeamSelector,
} from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import {
  competitionOptionsAtom,
  defaultCompetitionSectionCycleAtom,
  haveCompetitionOptionsLoadedAtom,
} from '@/atoms/filters/highLevel/competitions';
import { playerOptionsAtom } from '@/atoms/filters/highLevel/players';
import { haveSeasonOptionsLoadedAtom, seasonOptionsAtom } from '@/atoms/filters/highLevel/seasons';
import { teamOptionsAtom } from '@/atoms/filters/highLevel/teams';
import { isPopulatingPlayerCacheAtom } from '@/atoms/queries/players';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';

const unwrappedCompetitionOptionsAtom = unwrap(competitionOptionsAtom, prev => prev ?? []);
const unwrappedSeasonOptionsAtom = unwrap(seasonOptionsAtom, prev => prev ?? []);
const unwrappedTeamOptionsAtom = unwrap(teamOptionsAtom, prev => prev ?? []);
const unwrappedCyclesAtom = unwrap(defaultCompetitionSectionCycleAtom, prev => prev ?? []);

const unwrappedPlayerOptionsAtom = unwrap(playerOptionsAtom, prev => prev ?? null);
const unwrappedIsPopulatingPlayerCacheAtom = unwrap(isPopulatingPlayerCacheAtom, prev => prev ?? true);

const DataLockerHighLevelFiltersContent = () => {
  const competitionOptions = useAtomValue(unwrappedCompetitionOptionsAtom);
  const seasonOptions = useAtomValue(unwrappedSeasonOptionsAtom);
  const teamOptions = useAtomValue(unwrappedTeamOptionsAtom);
  const cycles = useAtomValue(unwrappedCyclesAtom);
  const showTracking = usePhysicalMetricsFeature();
  const playerOptions = useAtomValue(unwrappedPlayerOptionsAtom);
  const isPopulatingPlayerCache = useAtomValue(unwrappedIsPopulatingPlayerCacheAtom);
  const haveCompetitionOptionsLoaded = useAtomValue(haveCompetitionOptionsLoadedAtom);
  const haveSeasonOptionsLoaded = useAtomValue(haveSeasonOptionsLoadedAtom);

  const playersLoading =
    playerOptions === null || isPopulatingPlayerCache || !haveCompetitionOptionsLoaded || !haveSeasonOptionsLoaded;

  return (
    <>
      <ResetAllFiltersButton />
      <CompetitionSelector options={competitionOptions} playerCycles={cycles} showTracking={showTracking} />
      <SeasonSelector options={seasonOptions} />
      <TeamSelector options={teamOptions} />
      <PlayerSelector options={playerOptions ?? []} isLoading={playersLoading} />
      <DateRangeSelector />
    </>
  );
};

export const DataLockerHighLevelFilters = () => (
  <FilterScopeProvider scope="main">
    <DataLockerHighLevelFiltersContent />
  </FilterScopeProvider>
);
